// for localized-link
document.addEventListener('DOMContentLoaded', () => {
  const pathSegments = window.location.pathname.split('/');
  const possibleLang = pathSegments[1];
  const isLang = /^[a-z]{2}$/.test(possibleLang);

  document.querySelectorAll('.localized-link').forEach(link => {
    const href = link.getAttribute('href');

    if (href.startsWith('/') && !/^\/[a-z]{2}\//.test(href)) {
      const newHref = isLang ? `/${possibleLang}${href}` : href;
      link.setAttribute('href', newHref);
    }
  });
});